


































import { Component, Emit, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
import { percentage, color, required } from '@/utils/validate';
import { IDetailRecord } from '@/store/tool/imgcolor/types';
import PageList from '@/components/page/Index.vue';

interface IListRecord {
  id: number;
  hex: string;
  rgb: string;
  count: number;
  percent: string;
}

@Component({
  components: { PageList },
})
export default class ToolImgColorList extends Vue {
  @Prop() public data!: IDetailRecord;
  @Ref('form') public formRef!: HTMLFormElement;

  public color = color;
  public required = required;
  public percentage = percentage;
  public list: IListRecord[] = [];
  public headers = [
    { text: '移除', value: 'remove', align: 'center', width: '60px' },
    { text: '颜色预览', value: 'color' },
    { text: 'HEX颜色', value: 'hex' },
    { text: 'RGB颜色', value: 'rgb' },
    { text: '像素数量', value: 'count' },
    { text: '颜色占比', value: 'percent' },
  ];

  // 关闭编辑弹框
  @Emit('change')
  public onSave() {
    return this.list;
  }

  // 移除颜色
  @Emit('change')
  public onRemove(record: IListRecord) {
    this.list = this.list.filter((item) => item.id !== record.id);
    return this.list;
  }

  // 加载初始列表
  @Watch('data', { immediate: true })
  public dataChange(value: IDetailRecord | null) {
    if (!value) {
      this.list = [];
      return;
    }
    this.list = (value.pallete || []).map((item, index) => {
      const percent = `${(item.perc * 100).toFixed(3)}%`;
      const hex = item.color.toUpperCase();
      const rgb = [item.color_r, item.color_g, item.color_b].join(',');
      return { percent, hex, rgb, count: item.count, id: index + 1 };
    });
  }
}
